import { useTranslation as usePublicI18n } from "react-i18next";
import { publicText, publicTemplate } from "./publicText";
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightOutlined, ExperimentOutlined, LineChartOutlined, SearchOutlined, RadarChartOutlined, SafetyCertificateOutlined, EyeOutlined } from "@ant-design/icons";
import PublicLayout from "./PublicLayout";
import { CASE_STUDIES } from "./caseStudyData";
import { Reveal, useDocumentTitle } from "./components/PageUtilities";
import { ScientificNote } from "./components/ScientificComponents";
import { trackEvent } from "../FirebaseConfig";
const icons = [<ExperimentOutlined />, <RadarChartOutlined />, <LineChartOutlined />];
function CaseStudies() {
  usePublicI18n();
  useDocumentTitle(publicText("StomataScope Case Studies｜気孔から植物応答を読み解く"));
  return <PublicLayout>
      <section className="science-index-hero">
        <div className="science-orb orb-a" />
        <div className="science-orb orb-b" />
        <div className="science-grid-background" />

        <div className="case-container science-index-hero__inner">
          <Reveal className="science-index-hero__copy">
            <div className="science-index-kicker">
              <span />{publicText(" STOMATA SCOPE / PLANT PHYSIOLOGY ARCHIVE")}</div>
            <h1>{publicText("\u690D\u7269\u306E\u53CD\u5FDC\u3092\u3001")}<br />
              <em>{publicText("\u6C17\u5B54\u304B\u3089\u8AAD\u307F\u89E3\u304F\u3002")}</em>
            </h1>
            <p>{publicText("\u9855\u5FAE\u93E1\u753B\u50CF\u3092AI\u3067\u89E3\u6790\u3057\u3001Open / Closed\u3001Stomatal Aperture\u3001 \u5206\u5E03\u3001\u74B0\u5883\u30FB\u5149\u5408\u6210\u3068\u306E\u95A2\u4FC2\u3092\u5B9F\u6E2C\u30C7\u30FC\u30BF\u304B\u3089\u691C\u8A0E\u3059\u308B\u5C02\u9580Case Study\u30B5\u30A4\u30C8\u3067\u3059\u3002")}</p>

            <div className="science-index-hero__actions">
              <a href="#study-index" className="science-button is-primary">{publicText("Study Index ")}<ArrowRightOutlined />
              </a>
              <Link to="/login" className="science-button is-secondary">{publicText("StomataScope Login")}</Link>
            </div>

            <div className="science-index-hero__facts">
              <div>
                <strong>{publicText("Open / Closed")}</strong>
                <span>{publicText("AI classification")}</span>
              </div>
              <div>
                <strong>{publicText("\xB5m-scale")}</strong>
                <span>{publicText("Aperture quantification")}</span>
              </div>
              <div>
                <strong>{publicText("Context-aware")}</strong>
                <span>{publicText("Environment & physiology")}</span>
              </div>
            </div>
          </Reveal>

          <Reveal className="science-index-hero__visual" delay={120}>
            <div className="science-index-hero__image">
              <img src={CASE_STUDIES[0].image} alt={publicText("トマト苗を用いた処理比較試験")} />
              <div className="science-index-hero__image-overlay" />
              <span>{publicText("FIELD OBSERVATION / TOMATO")}</span>
            </div>

            <div className="science-floating-panel panel-primary">
              <small>{publicText("ANALYSIS LAYERS")}</small>
              <div>
                <span><SearchOutlined />{publicText(" Image")}</span>
                <span><RadarChartOutlined />{publicText(" Distribution")}</span>
                <span><LineChartOutlined />{publicText(" Time series")}</span>
              </div>
            </div>

            <div className="science-floating-panel panel-stat">
              <small>{publicText("FEATURED DATASET")}</small>
              <strong>{publicText("14,563")}</strong>
              <span>{publicText("stomata / 7 time points")}</span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="research-approach-section">
  <div className="case-container">

    <div className="research-approach-head reveal">
      <span className="rich-section-label">{publicText("RESEARCH APPROACH")}</span>

      <h2>{publicText("\u690D\u7269\u5FDC\u7B54\u3092\u3001")}<br />{publicText("\u753B\u50CF\u30FB\u5206\u5E03\u30FB\u74B0\u5883\u306E3\u5C64\u3067\u8AAD\u3080\u3002")}</h2>

      <p>{publicText("\u690D\u7269\u306E\u72B6\u614B\u3092\u5916\u89B3\u3060\u3051\u3067\u5224\u65AD\u305B\u305A\u3001 \u6C17\u5B54\u753B\u50CF\u3001Open\u7387\u30FB\u6C17\u5B54\u958B\u5EA6\u306E\u5206\u5E03\u3001 \u305D\u3057\u3066\u74B0\u5883\u30FB\u51E6\u7406\u6761\u4EF6\u3092\u91CD\u306D\u3066\u8A55\u4FA1\u3057\u307E\u3059\u3002 \u5404Case Study\u3067\u306F\u3001\u89B3\u5BDF\u3067\u304D\u305F\u4E8B\u5B9F\u3068\u3001 \u307E\u3060\u65AD\u5B9A\u3067\u304D\u306A\u3044\u3053\u3068\u3092\u5206\u3051\u3066\u793A\u3057\u307E\u3059\u3002")}</p>
    </div>

    <div className="research-flow reveal">

      <div className="research-flow-item">
        <span className="research-flow-number">{publicText("01")}</span>

        <div className="research-flow-icon">
          <EyeOutlined />
        </div>

        <div className="research-flow-en">{publicText("IMAGE")}</div>

        <h3>{publicText("\u6C17\u5B54\u3092\u76F4\u63A5\u898B\u308B")}</h3>

        <p>{publicText("\u8449\u9762\u306E\u6C17\u5B54\u3092\u753B\u50CF\u3068\u3057\u3066\u53D6\u5F97\u3057\u3001 Open / Closed\u3084\u500B\u3005\u306E\u5F62\u614B\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002")}</p>
      </div>

      <div className="research-flow-line">
        <span />
      </div>

      <div className="research-flow-item">
        <span className="research-flow-number">{publicText("02")}</span>

        <div className="research-flow-icon">
          <LineChartOutlined />
        </div>

        <div className="research-flow-en">{publicText("QUANTIFICATION")}</div>

        <h3>{publicText("\u5206\u5E03\u3068\u3057\u3066\u6E2C\u308B")}</h3>

        <p>{publicText("Open\u7387\u3001\u6C17\u5B54\u958B\u5EA6\u3001\u30D2\u30B9\u30C8\u30B0\u30E9\u30E0\u3001 \u7BB1\u3072\u3052\u56F3\u306A\u3069\u304B\u3089\u96C6\u56E3\u306E\u5FDC\u7B54\u3092\u5B9A\u91CF\u5316\u3057\u307E\u3059\u3002")}</p>
      </div>

      <div className="research-flow-line">
        <span />
      </div>

      <div className="research-flow-item">
        <span className="research-flow-number">{publicText("03")}</span>

        <div className="research-flow-icon">
          <ExperimentOutlined />
        </div>

        <div className="research-flow-en">{publicText("CONTEXT")}</div>

        <h3>{publicText("\u74B0\u5883\u3068\u91CD\u306D\u3066\u8AAD\u3080")}</h3>

        <p>{publicText("\u6C17\u6E29\u3001\u4E7E\u71E5\u3001\u5149\u3001\u704C\u6C34\u3001\u8CC7\u6750\u51E6\u7406\u3001 \u690D\u7269\u5916\u89B3\u306A\u3069\u3068\u7167\u5408\u3057\u306A\u304C\u3089\u89E3\u91C8\u3057\u307E\u3059\u3002")}</p>
      </div>

    </div>

  </div>
    </section>

      <section className="science-study-index" id="study-index">
        <div className="case-container">
          <Reveal className="science-study-index__heading">
            <div>
              <span className="science-eyebrow">{publicText("STUDY INDEX")}</span>
              <h2>{publicText("\u73FE\u5728\u516C\u958B\u3057\u3066\u3044\u308B\u89E3\u6790\u4E8B\u4F8B")}</h2>
            </div>
            <p>{publicText("\u51E6\u7406\u5FDC\u7B54\u3001\u8907\u5408\u30B9\u30C8\u30EC\u30B9\u3001\u65E5\u5468\u5909\u5316\u3068\u3044\u3046\u7570\u306A\u308B\u89B3\u70B9\u304B\u3089\u3001 \u6C17\u5B54\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u65B9\u3092\u6574\u7406\u3057\u3066\u3044\u307E\u3059\u3002")}</p>
          </Reveal>

          <div className="science-study-grid">
            {publicText(CASE_STUDIES.map((study, index) => <Reveal key={study.id} delay={index * 90}>
                <Link to={study.path} className={`science-study-card ${index === 2 ? "is-featured" : ""}`}>
                  <div className="science-study-card__media">
                    <img src={study.image} alt={publicText(study.title)} />
                    <div className="science-study-card__media-overlay" />
                    <span>{publicText("CASE STUDY ")}{publicText(study.id)}</span>
                  </div>

                  <div className="science-study-card__body">
                    <div className="science-study-card__icon">{publicText(icons[index])}</div>
                    <small>{publicText(study.kicker)}</small>
                    <h3>{publicText(study.title)}</h3>
                    <p>{publicText(study.summary)}</p>

                    <div className="science-study-card__tags">
                      {publicText(study.tags.map(tag => <span key={tag}>{publicText(tag)}</span>))}
                    </div>

                    <div className="science-study-card__result">
                      <div>
                        <strong>{publicText(study.featuredValue)}</strong>
                        <span>{publicText(study.featuredLabel)}</span>
                      </div>
                      <ArrowRightOutlined />
                    </div>
                  </div>
                </Link>
              </Reveal>))}
          </div>
        </div>
      </section>

      <section className="science-index-scope">
        <div className="study-content">
          <Reveal>
            <span className="science-eyebrow">{publicText("SCOPE & EVIDENCE")}</span>
            <h2>{publicText("\u6C17\u5B54\u3092\u3001\u5358\u72EC\u306E\u201C\u7B54\u3048\u201D\u3067\u306F\u306A\u304F\u3001\u751F\u7406\u72B6\u614B\u3092\u8AAD\u3080\u4E00\u5C64\u3068\u3057\u3066\u6271\u3046\u3002")}</h2>
          </Reveal>

          <div className="science-index-scope__grid">
            <Reveal delay={80}>
              <strong>{publicText("\u6C17\u5B54\u753B\u50CF")}</strong>
              <p>{publicText("Open / Closed\u3001\u958B\u5EA6\u3001\u9762\u7A4D\u3001\u5F62\u72B6\u306A\u3069\u3092\u500B\u3005\u306E\u6C17\u5B54\u304B\u3089\u53D6\u5F97\u3002")}</p>
            </Reveal>
            <Reveal delay={140}>
              <strong>{publicText("\u690D\u7269\u4F53\u30FB\u8449\u6E29")}</strong>
              <p>{publicText("\u5916\u89B3\u5199\u771F\u3084\u30B5\u30FC\u30E2\u30B0\u30E9\u30D5\u30A3\u30FC\u3068\u7167\u5408\u3057\u3001\u898B\u305F\u76EE\u3068\u306E\u4E00\u81F4\u30FB\u4E0D\u4E00\u81F4\u3092\u78BA\u8A8D\u3002")}</p>
            </Reveal>
            <Reveal delay={200}>
              <strong>{publicText("\u74B0\u5883\u30FB\u30AC\u30B9\u4EA4\u63DB")}</strong>
              <p>{publicText("PPFD\u3001\u6E29\u6E7F\u5EA6\u3001VPD\u3001CO\u2082\u3001\u5149\u5408\u6210\u901F\u5EA6\u3068\u540C\u3058\u6642\u9593\u8EF8\u3067\u89E3\u91C8\u3002")}</p>
            </Reveal>
          </div>

          <ScientificNote title={publicText("公開情報の位置づけ")} tone="caution">
            <p>{publicText("\u672C\u30B5\u30A4\u30C8\u306E\u4E8B\u4F8B\u306F\u3001\u7279\u5B9A\u6761\u4EF6\u4E0B\u3067\u5F97\u3089\u308C\u305F\u63A2\u7D22\u7684\u30C7\u30FC\u30BF\u3067\u3059\u3002 \u8CC7\u6750\u306E\u4E00\u822C\u7684\u52B9\u679C\u3084\u512A\u52A3\u3092\u4FDD\u8A3C\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002 \u56E0\u679C\u63A8\u8AD6\u3084\u88FD\u54C1\u8A55\u4FA1\u306B\u306F\u3001\u72EC\u7ACB\u3057\u305F\u690D\u7269\u500B\u4F53\u3092\u7528\u3044\u305F\u751F\u7269\u5B66\u7684\u53CD\u5FA9\u3001 \u6761\u4EF6\u7D71\u4E00\u3001\u9069\u5207\u306A\u591A\u91CD\u6BD4\u8F03\u30FB\u968E\u5C64\u30E2\u30C7\u30EB\u7B49\u304C\u5FC5\u8981\u3067\u3059\u3002")}</p>
          </ScientificNote>
        </div>
      </section>
    </PublicLayout>;
}
export default CaseStudies;
